<template>
  <div
    class="
      min-h-screen
      bg-brand-blue
      m-0
      p-0
      flex
      items-center
      justify-center
      bg-genius
      flex-col
    "
  >
    <div class="w-3/4 md:w-1/2 bg-white max-w-md shadow-20" v-if="!loggedIn">
      <div class="flex justify-center items-center p-2" v-if="logo">
        <img :src="logo" style="height: 150px" />
      </div>
      <div class="mx-4 md:mx-12 my-8">
        <p class="mb-3 text-sm">{{ ErrorMessage }}</p>
        <input
          type="text"
          v-model="username"
          class="text-input"
          placeholder="Username"
        />
        <input
          type="password"
          v-model="password"
          class="text-input"
          placeholder="Password"
          autocomplete="off"
          @keyup.enter="login"
        />
        <button class="btn active:bg-blue-400 hover:bg-blue-400" @click="login">
          login
        </button>
        <div class="flex w-full">
          <router-link class="p-1" :to="{ name: 'Register' }"
            >Register here</router-link
          >
          <span class="flex-grow"></span>
          <router-link class="p-1" :to="{ name: 'ResetPassword' }"
            >Forgot password?</router-link
          >
        </div>
      </div>
    </div>
    <div
      class="w-3/4 md:w-1/2 bg-white max-w-md shadow-20 p-10"
      v-if="loggedIn"
    >
      <p>
        If you are using a shared PC please make sure to log out at the end of
        your session
      </p>
      <input
        type="button"
        style="margin-top: 10px"
        @click="confirm()"
        class="btn cursor-pointer"
        value="Confirm"
      />
    </div>
    <div class="flex mt-2">
      <p class="p-2">Powered by Adept © Genius Software Solutions</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      ErrorMessage: "",
      logo: "",
      loggedIn: false,
    };
  },

  beforeMount() {
    this.CheckLoggedIn();
    this.$store.commit("change", null);
  },

  mounted(){
    this.getLogo();
  },

  methods: {
    getLogo() {
      var url = document.location.hostname;
      var images = require.context("../assets/logos/", false, /\.png$/);
      var tenant = "";
      if (url.includes("smfmotor")) tenant = "smf"
      this.logo = !tenant ? null : images("./" + tenant + ".png");
    },

    CheckLoggedIn() {
      if (localStorage.getItem("token") != null) {
        localStorage.removeItem("token");
      }
    },
    confirm() {
      this.$router.push({ name: "CustomerDetails" });
    },
    login() {
      if (!this.username || !this.password) {
        this.ErrorMessage = "A username and password must be present";
      } else {
        this.$http
          .post("Authenticate/partyLogin", {
            login: this.username,
            password: this.password,
          })
          .then(
            (res) => {
              localStorage.setItem("token", res.data);
              this.loggedIn = true;
            },
            (error) => {
              if (error.message.includes("401")) {
                this.ErrorMessage = error.response.data;
              }
            }
          );
      }
    },
  },
};
</script>